export default __webpack_public_path__ + "static/media/smile.2d577718.svg";